
import { authHeader } from '../../../_helpers';
import axios from 'axios';

export const sellerAdminService = {
    getSellerAdmin,
    removeSellerAdmin,
    addSellerAdmin,
    makePrimaryAdmin
};

axios.defaults.headers.common = authHeader();

function getSellerAdmin(id) {
    return axios.get('/users/seller/admin/list/' + id + '/'
    ).then(response => {

        return response;
    });
}

function addSellerAdmin(data) {


    return axios.post('/users/add/seller/admin/', data).then(response => {

        return response;
    });
}

function makePrimaryAdmin(data) {
    return axios.post('/users/make/seller/primary/admin/', data).then(response => {

        return response;
    });
}

function removeSellerAdmin(data) {
    return axios.post('/users/remove/seller/admin/', data).then(response => {

        return response;
    });
}



// WEBPACK FOOTER //
// ./src/_services/sellers/sellerAdmin/sellerAdmin.service.js